import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CartInDialog } from '@component/Dialog';
import { addCartDialogAction } from '@app/react/action';
import type { AsyncGeneralState } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';

const selectCartInState = (state: AppState): AsyncGeneralState => state.uiCustomDesign.cartInState;

export const CartInDialogContainer: FC = () => {
    const dispatch = useDispatch();
    const cartInState = useSelector(selectCartInState);

    return (
        <CartInDialog
            isShow={cartInState === 'done'}
            toNextProps={{
                onClick: () => {
                    dispatch(addCartDialogAction({ show: false }));
                },
            }}
            toECProps={{
                href: '/',
            }}
            toCartProps={{
                href: '/cart',
            }}
        />
    );
};
